import React from 'react'
import Home from '../Components/Home/Home'
import MetricsDashboard from '../Components/Home/MetricsDashboard'
import About from '../Components/About/About'
import Project from '../Components/Projects/Project'
import ExtraSections from '../Components/Home/ExtraSections'
import Skills from '../Components/Skills/Skills'
import { useEffect } from 'react'
import Cookies from 'js-cookie'
import { useNavigate, useLocation } from 'react-router-dom'

const HomePage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    if (token) {
      Cookies.set("token", token, { expires: 7 });
      navigate('/');
    }

    if (location.hash) {
      const id = location.hash.substring(1);
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, [navigate, location]);

  return (
    <>
    <Home/>
    <MetricsDashboard/>
    <About/>
    <Project/>
    <ExtraSections/>
    <Skills/>
    </>
  )
}

export default HomePage